import React from 'react'
import { CustomMainContent } from '../../components'
import { pdf } from '../../assets/pdf'

export const TrainingHelp = () => {
    return (
        <CustomMainContent>
            <div className="flex h-full w-full min-w-[800px] pr-4">
                {/* <div className="h-full w-3/12 bg-green-400"></div> */}
                <div className="h-full w-full bg-white">
                    <iframe src={pdf.manulVRL + "#view=FitH&toolbar=0&navpanes=0"} title='pdf ' className='w-full h-full' frameBorder="0"></iframe>
                </div>
            </div>
        </CustomMainContent>
    )
}
